import React, { useMemo } from 'react';
import { ProductItemResponse } from '@/api/product/types';
import { Button, Icon, InfoList } from '@/components/shared';
import { SparePartRegistrationResponse, TranslationsWebsiteSparePartRegistrations } from '@/generated/data.schemas';
import { formatDate } from '@/helpers/dateHelpers';
import { getArticleName } from '@/helpers/getArticleName';
import styles from './SparePart.module.scss';


interface SparePartProps {
	data: SparePartRegistrationResponse;
	translations?: TranslationsWebsiteSparePartRegistrations;
	productItems?: ProductItemResponse[] | null;
	handleClick: (sparePart: SparePartRegistrationResponse) => void;
	isOpen: boolean;
	ariaControlId: string;
	cultureCode: string;
}

export const SparePart: React.FunctionComponent<SparePartProps> = ({
	data,
	translations,
	productItems,
	handleClick,
	isOpen,
	ariaControlId,
	cultureCode,
}) => {
	const sparePartData = useMemo(() => {
		return {
			description: getArticleName(productItems, data.articleNumber),
			articleNo: data.articleNumber,
			quantity: data.quantity,
			saleDate: data.saleDate ? formatDate(data.saleDate, cultureCode) : '',
		};
	}, [cultureCode, data, productItems]);
	return (
		<div className={styles.table}>
			<InfoList data={sparePartData} translations={translations} listOnly />

			{/* Trigger button for edit */}
			<Button
				className={styles.hoverEditBtn}
				size={'sm'}
				variant={'ghost'}
				onClick={() => handleClick(data)}
				aria-expanded={isOpen}
				aria-controls={ariaControlId}
			>
				<Icon name={'edit'} size={'sm'} />
			</Button>
		</div>
	);
};
